import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'sc-mobile-planning',
  styleUrls: ['./mobile-planning.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<router-outlet
    (activate)="onPageActivated($event)"
  ></router-outlet>`,
  imports: [RouterOutlet],
})
export class MobilePlanningComponent {
  currentPageInstance = new EventEmitter<any>();

  onPageActivated($event) {
    this.currentPageInstance.next($event);
  }
}
